<template>
  <div ref="whole_page">
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="$siteTypeId() != 1 && !loadingView && !errorLoadingView">
      <vx-card title="Outcomes and Unit standards" class="mb-4">
        <div class="vx-row vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
          
          <div v-if="outcome" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Outcome</h4>
            <table >
              <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{outcome.name}}</p></td></tr>
              <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{outcome.description}}</p></td></tr>
            </table>
          </div>
          <div v-else>
            <h4>Outcome</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
          
          <div  v-if="standard" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Unit Standard</h4>
              <table>
                <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{standard.name}}</p></td></tr>
                <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{standard.description}}</p></td></tr>
              </table>
          </div>
          <div v-else>
            <h4>Unit Standard</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
        </div>
      </vx-card>
    </div>
    <!-- Quiz -->
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :studentName="taskResults.fullname" :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question   :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question   :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question   :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question   :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question   :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question   :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'LikertScale'">
          <likert-scale-question   :isCardActive="likertScaleQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :studentName="taskResults.fullname"  :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :info="taskResults" :newScore="quizAchievedMarks" :freeTextTotal="quizTotalMarks" :newQuizTotal="quizTotalMarks" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question  :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question   :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question  :isCardActive="tableQuestion" @loadTask="loadTask" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop  :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- Upload -->
          <upload-question :isCardActive="uploadQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    
    <!-- Upload -->

    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view  :isCardActive="uploadTaskView" :uploadTask="taskResults" />
    </div>

    <!-- Video Capture -->

    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view  :isCardActive="captureTaskView" :captureTask="taskResults" />
    </div>
    <div class="w-full pb-6 mb-6">
      <vs-button v-if="!loadingView && !errorLoadingView" style="float:right" color="warning" type="border" class="mb-6" @click="closeTask">Close</vs-button>
    </div>
  </div>
</template>

<script>
import ispringQuizInfoView from "../../assessor/assessmentviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "../../assessor/assessmentviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "../../assessor/assessmentviews/MultipleResponseQuestion.vue";
import textQuestion from "../../assessor/assessmentviews/TextQuestion.vue";
import sequenceQuestion from "../../assessor/assessmentviews/SequenceQuestion.vue";
import matchingQuestion from "../../assessor/assessmentviews/MatchingQuestion.vue";
import sentenceQuestion from "../../assessor/assessmentviews/SentenceQuestion.vue";
import likertScaleQuestion from "../../assessor/assessmentviews/LikertScaleQuestion.vue";
import quizInfoView from "../../assessor/assessmentviews/QuizInfoView.vue";
import mcssQuestion from "../../assessor/assessmentviews/MCSSQuestion.vue";
import dragAndDrop from "../../assessor/assessmentviews/DragAndDrop.vue";
import mcmsQuestion from "../../assessor/assessmentviews/MCMSQuestion.vue";
import freeTextQuestion from "../../assessor/assessmentviews/FreeTextQuestion.vue";
import uploadQuestion from "../../assessor/assessmentviews/UploadQuestion.vue";
import tableQuestion from "../../assessor/assessmentviews/TableQuestion.vue";
import uploadTaskView from "../../assessor/assessmentviews/UploadTaskView.vue";
import captureTaskView from "../../assessor/assessmentviews/CaptureTaskView.vue";
import snapshotView from "../../assessor/assessmentviews/SnapshotsView.vue";
import loadingView from "../../assessor/assessmentviews/ResultsLoadingView.vue";
import errorLoadingView from "../../assessor/assessmentviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "../../assessor/assessmentviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "../../assessor/assessmentviews/QuizFinalCommentView.vue";
import uploadCommentView from "../../assessor/assessmentviews/UploadCommentView.vue";
import captureCommentView from "../../assessor/assessmentviews/CaptureCommentView.vue";

export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    likertScaleQuestion,
    quizInfoView,
    mcssQuestion,
    mcmsQuestion,
    dragAndDrop,
    freeTextQuestion,
    tableQuestion,
    uploadTaskView,
    captureTaskView,
    snapshotView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView,
    uploadQuestion,
  },
  data(){
    return{
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      likertScaleQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      uploadQuestion:true,
      tableQuestion: true,
      dragAndDropQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      predefinedComments: [],
      uploadedFileUrlList: [],
      isAllSummativeTaskAssessed: false,
      isTeacher: false,
      isStudent: false,
      initpondlable: "Drop upload files here or <span class='filepond--label-action'>Browse</span>",
      updatepondlable: "Drop updated files here or <span class='filepond--label-action'>Browse</span>",
      showCompletePopupActive: false,
      outcome:[],
      standard:[],
      isModuleContinuous:false,
      assessorFeedback:{
        studentId:0,
        isCompetent:false,
        hasCompletedQuizzes:false,
        hasCompletedJournals:false,
        hasCompletedLogbook:false,
        hasCompletedPersonalInfo:false,
        hasCompletedAssessmentPrep:false,
        hasCompletedAssessmentPlan:false,
        hasCompletedDeclarationofAuth:false,
        logId:0,
        assessorFeedbackAnswers:[]
      },
      assessorFeedbackAnswer:{
        id:0,
        agree:null,
        answer:null
      },
      questionList:[],
      popupHtml:``,
      freeTextPopup:``,
      lastIndex:0,
      assessorFeedbackPreviewPopup:false,
      assessorFeedbackData:{},
      varccsItems:[],
      varccHTML:"",
      varccComment:"",
      studentModuleId:0,
      reviewQuestions:[],
      reviewHTML:"",
    }
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;
        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    },
  },
  methods:{
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadTask() {
      const self = this;
      self.loadingView = true;
      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };
      self.$ajaxGet(self, "monitor/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    closeTask(){
      window.open("", "_self").close();
    },
    getStandardsAndOutcomes(){
      var self = this;
      var onSuccess = response =>{
        self.standard = response.data.standard;
        self.outcome = response.data.outcome;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_Page){
        }
      }
      //self.$route.query.TaskLogId
      self.$ajaxGet(self, "Course/GetOutcomeInfo/" + self.$route.query.TaskLogId , onSuccess, onFinally);
    },
  },
  mounted(){
    document.getElementById("btnSidebarToggler").click();
    this.initValues();
    this.getStandardsAndOutcomes();
    this.loadTask();
  }
}
</script>

<style>

</style>